import React from 'react'

import styles from './EmptyTableDiamonds.module.css'

const EmptyTableDiamonds = () =>
  <div className={styles.emptyTableDiamondResults}>
    <div className={styles.mainHeader}>Add Your First Item</div>
    <div className={styles.subHeader}>
      Tap the green <strong>"Add an Item"</strong> button above to start adding
      your jewelry, loose diamonds or gemstones.<br />
      If you have a large amount of inventory, you can upload in bulk by tapping
      the <strong>"Bulk Upload"</strong> button above.
    </div>
  </div>

export default EmptyTableDiamonds
